import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
import loadConfig from "@Web3WalletConfig/config";
export default {
  name: "gift",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", 'setting'])
  },
  data() {
    return {
      loadConfig,
      isLock: false,
      list: {},
      popTaskShow: false,
      modifyData: {
        "icon": ""
      },
      isLoading: false,
      item_id: 0,
      lottery_id: 0,
      total: 0,
      total_amount: 0,
      condition: {
        page: 1,
        limit: 15,
        status: ""
      },
      time: ["", ""],
      chainList: []
    };
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let rs = await this.$http.post("/withdrawlogs", {
        time: this.time,
        ...this.condition
      });
      this.isLoading = false;
      if (rs.code == 0) {
        this.list = rs.data.items;
        this.total = rs.data.total;
        this.total_amount = rs.data.total_amount;
      }
    },
    async onModify(item) {
      this.modifyData = item;
      this.popTaskShow = true;
    },
    cutStr(str) {
      if (str) return str.replace("T", " ").replace(".000Z", "");
    },
    onRefresh() {
      this.getData();
    },
    onPageChange(e) {
      this.condition.page = e;
      this.getData();
    },
    onPageSizeChange(e) {
      this.condition.limit = e;
      this.getData();
    },
    onDatePickerInput(val) {
      console.log("onDatePickerInput", val, this.time);
    },
    onChange(e) {
      this.condition.status = e;
    },
    onChangeToken(e) {
      this.condition.chain = e.split("|")[0] || '';
      this.condition.symbol = e.split("|")[1] || '';
    },
    onStat() {
      this.$router.push("/withdrawstat");
    }
  },
  async mounted() {
    let chainList = [];
    let rs = await this.$http.post("/assets/chains", {});
    if (rs.code == 0) {
      chainList = rs.data;
    }
    rs = await this.$http.post("/assets/tokens", {
      chain_id: this.chain_id
    });
    if (rs.code == 0) {
      rs.data.map(item => {
        chainList.map(sitem => {
          if (!sitem.tokens) {
            sitem.tokens = [];
          }
          if (sitem.id == item.chain) {
            sitem.tokens.push(item);
          }
          return sitem;
        });
      });
    }
    this.chainList = chainList;
    this.onChangeToken((this.chainList[0]['tokens'][0]['chain'] || '') + "|" + (this.chainList[0]['tokens'][0]['symbol'] || ''));
    this.getData();
  }
};